// 快手实名认证状态管理模块
const state = {
  userEmergencyContacts: [], // 用户紧急联系人列表
  relationshipOptions: [], // 关系选项列表
  progress: '', // 认证进度
  userIdentify: null, // 用户实名认证信息
  isAgainSubmit: false, // 是否再次提交
}

const mutations = {
  SET_USER_EMERGENCY_CONTACTS: (state, contacts) => {
    state.userEmergencyContacts = contacts
  },
  SET_RELATIONSHIP_OPTIONS: (state, options) => {
    state.relationshipOptions = options
  },
  SET_PROGRESS: (state, progress) => {
    state.progress = progress
  },
  SET_USER_IDENTIFY: (state, userIdentify) => {
    state.userIdentify = userIdentify
  },
  SET_AGAIN_SUBMIT: (state, status) => {
    state.isAgainSubmit = status
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
